// Action
import ActionArm from './action/Arm.json';
import ActionBrakePX4Rover from './action/BrakePX4Rover.json';
import ActionChangeSpeed from './action/ChangeSpeed.json';
import ActionDisarm from './action/Disarm.json';
import ActionElevateArduPilot from './action/ElevateArduPilot.json';
import ActionGoto from './action/Goto.json';
import ActionGripper from './action/Gripper.json';
import ActionHold from './action/Hold.json';
import ActionLandArduPlane from './action/LandArduPlane.json';
import ActionManual from './action/Manual.json';
import ActionMotorTest from './action/MotorTest.json';
import ActionReturn from './action/Return.json';
import ActionSetHome from './action/SetHome.json';
import ActionSetMode from './action/SetMode.json';
import ActionSetServo from './action/SetServo.json';
import ActionStickControl from './action/StickControl.json';
import ActionTakeoff from './action/Takeoff.json';
// Calibration
import CalibrationAccelerometerNext from './calibration/AccelerometerNext.json';
import CalibrationAccelerometerStart from './calibration/AccelerometerStart.json';
import CalibrationAirspeed from './calibration/Airspeed.json';
import CalibrationCompassCancel from './calibration/CompassCancel.json';
import CalibrationCompassStart from './calibration/CompassStart.json';
import CalibrationGyroscope from './calibration/Gyroscope.json';
import CalibrationLevelHorizon from './calibration/LevelHorizon.json';
import CalibrationReboot from './calibration/Reboot.json';
// Camera
import CameraGimbalMove from './camera/GimbalMove.json';
import CameraGimbalReset from './camera/GimbalReset.json';
import CameraShoot from './camera/Shoot.json';
// GPS
import GpsSendRtcm from './gps/SendRtcm.json';
// Mission
import MissionClear from './mission/Clear.json';
import MissionRequestItem from './mission/RequestItem.json';
import MissionRequestList from './mission/RequestList.json';
import MissionSendAck from './mission/SendAck.json';
import MissionSendCount from './mission/SendCount.json';
import MissionSendItem from './mission/SendItem.json';
import MissionStartArduPilot from './mission/StartArduPilot.json';
import MissionStartPX4 from './mission/StartPX4.json';
// Parameter
import ParamList from './param/List.json';
import ParamRead from './param/Read.json';
import ParamSet from './param/Set.json';
// Request
import RequestAutopilotVersion from './request/AutopilotVersion.json';
import RequestDataStream from './request/DataStream.json';
import RequestHeartbeat from './request/Heartbeat.json';
import RequestMessageInterval from './request/MessageInterval.json';

const messages = [
  // Action
  ActionArm,
  ActionBrakePX4Rover,
  ActionChangeSpeed,
  ActionDisarm,
  ActionElevateArduPilot,
  ActionGoto,
  ActionGripper,
  ActionHold,
  ActionLandArduPlane,
  ActionManual,
  ActionMotorTest,
  ActionReturn,
  ActionSetHome,
  ActionSetMode,
  ActionSetServo,
  ActionStickControl,
  ActionTakeoff,
  // Calibration
  CalibrationAirspeed,
  CalibrationAccelerometerNext,
  CalibrationAccelerometerStart,
  CalibrationCompassCancel,
  CalibrationCompassStart,
  CalibrationGyroscope,
  CalibrationLevelHorizon,
  CalibrationReboot,
  // Camera
  CameraGimbalMove,
  CameraGimbalReset,
  CameraShoot,
  // GPS
  GpsSendRtcm,
  // Mission
  MissionClear,
  MissionRequestItem,
  MissionRequestList,
  MissionSendAck,
  MissionSendCount,
  MissionSendItem,
  MissionStartArduPilot,
  MissionStartPX4,
  // Parameter
  ParamList,
  ParamRead,
  ParamSet,
  // Request
  RequestAutopilotVersion,
  RequestDataStream,
  RequestHeartbeat,
  RequestMessageInterval,
];

const messageSet = {};
messages.forEach((message) => {
  messageSet[message.name] = {
    sysId: message.sysId,
    compId: message.compId,
    messages: message.messages,
  };
});

export default messageSet;
